import { Box, Button, Progress, Stack, Text } from "@chakra-ui/react";
import { FiRefreshCw } from "react-icons/fi";
import { ImCancelCircle } from "react-icons/im";

const UploadProgress = ({
  documentType,
  isUploading,
  uploadProgress,
  initiateCancelUploadProcess,
  onRetry,
  uploadFailed,
}) => {
  return (
    <Box mt={5}>
      <Box
        display={"flex"}
        justifyContent={"space-between"}
        alignItems={"center"}
      >
        <Text fontSize={"xs"} fontWeight={"semibold"}>
          {documentType + (uploadFailed ? " Failed" : "")}
        </Text>
        <Text
          fontSize="xs"
          ml={2}
          color={"orange.400"}
          fontWeight={"semibold"}
        >{`${uploadProgress}%`}</Text>
      </Box>
      <Box display="flex" alignItems="center" mt={2}>
        <Progress
          value={uploadProgress}
          size="xs"
          colorScheme={uploadFailed ? "red" : "orange"}
          flex="1" // Take up available space
          borderRadius={"20px"}
        />
      </Box>
      <Stack direction="row" alignItems="center" mt={2}>
        {isUploading ? (
          <>
            <Button
              size="xs"
              colorScheme="orange"
              onClick={initiateCancelUploadProcess}
              variant={"unstyled"}
              color={"gray.500"}
              display={"flex"}
              columnGap={"1"}
              fontWeight={"semibold"}
            >
              <ImCancelCircle />
              Cancel Upload
            </Button>
          </>
        ) : uploadFailed ? (
          <Button
            size="xs"
            colorScheme="teal"
            onClick={onRetry}
            variant={"unstyled"}
            color={"teal.500"}
            display={"flex"}
            columnGap={"1"}
            fontWeight={"semibold"}
          >
            <FiRefreshCw />
            Retry Upload
          </Button>
        ) : null}
      </Stack>
    </Box>
  );
};

export default UploadProgress;
